const getTemplateSwitched = (rootState) => rootState.site.templateSwitched;

export default getTemplateSwitched;
